function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { defineComponent, reactive, computed, watch, toRefs, ref, onMounted } from "vue";
import { fileUploadModel, fromUploadSchemaFun, fromUploadColumnFun } from "../config/form";
import TableList from "@/components/TableList/index.vue";
import { getFileUploadConfig } from "../config/dialog";
import { realizeOptions, applicableOptions } from "../config/option";
import { validateName } from "../config/form";
import CoverUploader from "../modular/upload-modular.vue";
import tagTascader from "@/views/repository/labels/components/tag-cascader.vue";
import store from "@/store";
import _ from "lodash";
export default defineComponent({
    name: "upload-dialog",
    components: {
        TableList: TableList,
        CoverUploader: CoverUploader,
        tagTascader: tagTascader
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var uploadTips = ref("");
        var tableListRef = ref();
        var resource = computed(function() {
            return store.state.resource;
        });
        var uploadConfig = reactive({
            type: "thumb",
            accept: [
                "png",
                "jpg",
                "gif",
                "jpeg",
                "svg"
            ],
            listType: "picture-card",
            paramsData: {
                mod: "",
                bucket: "mws-files"
            },
            coverSize: {
                width: 48,
                height: 48
            }
        });
        var fileUploadSchemaData = reactive({
            fileUploadSchema: {}
        });
        var fileUploadModelData = reactive({
            fileUploadModel: fileUploadModel
        });
        var uploadTable = reactive({
            uploadTableColumn: [],
            uploadTableList: fileUploadModel.file_path,
            uploadLoading: false
        });
        var tagConfig = computed(function() {
            var _activeTab;
            return {
                properties: {
                    isMultiple: true,
                    prop: "tag_ids",
                    treeParams: {
                        group_type: 4,
                        asset_type: (_activeTab = resource.value.activeTab) !== null && _activeTab !== void 0 ? _activeTab : 0
                    }
                }
            };
        });
        var handleDeleteFile = function(index) {
            uploadTable.uploadTableList.splice(index, 1);
        };
        var uploadCover = function(file_path, row) {
            row.thumb_url = file_path;
        };
        var uploadRemove = function(row) {
            row.thumb_url = "";
        };
        var tagChangeEvent = function(val, row) {
            if (val) {
                _.map(uploadTable.uploadTableList, function(item) {
                    item.access_allow_pt = false;
                    item.tag_ids = row.tag_ids;
                });
                row.access_allow_pt = true;
            }
        };
        var applicableToolsChangeEvent = function(val, row) {
            if (val) {
                _.map(uploadTable.uploadTableList, function(item) {
                    item.applicable_tools_apply_to_all = false;
                    item.applicable_tools = row.applicable_tools;
                });
                row.applicable_tools_apply_to_all = true;
            }
        };
        var realizeMethodChangeEvent = function(val, row) {
            if (val) {
                _.map(uploadTable.uploadTableList, function(item) {
                    item.realize_method_apply_to_all = false;
                    item.realize_method = row.realize_method;
                });
                row.realize_method_apply_to_all = true;
            }
        };
        var handleChange = function(row) {
            if (row.access_allow_pt) {
                row.access_allow_pt = false;
            }
            if (row.applicable_tools_apply_to_all) {
                row.applicable_tools_apply_to_all = false;
            }
            if (row.realize_method_apply_to_all) {
                row.realize_method_apply_to_all = false;
            }
        };
        watch(function() {
            return resource.value.activeTab;
        }, function(value) {
            uploadConfig.paramsData.mod = "asset-".concat(value);
            fileUploadSchemaData.fileUploadSchema = fromUploadSchemaFun(value);
            uploadTips.value = getFileUploadConfig(value).tip;
            uploadTable.uploadTableColumn = fromUploadColumnFun(value).filter(function(item) {
                return item.show;
            });
        }, {
            immediate: true
        });
        // watch(
        //   () => resource.value.visible,
        //   (val) => {
        //     if (val) {
        //       fileUploadModelData.fileUploadModel = { ...fileUploadModel }
        //       fileUploadModel.file_path = []
        //       tableListRef.value.doLayout()
        //       uploadTable.uploadTableList = fileUploadModel.file_path
        //     }
        //   },
        // )
        watch(function() {
            return uploadTable.uploadTableList;
        }, function(val) {
            emit("handleBatchChange", val);
        }, {
            deep: true
        });
        onMounted(function() {
            fileUploadModelData.fileUploadModel = _objectSpread({}, fileUploadModel);
            fileUploadModel.file_path = [];
            tableListRef.value.doLayout();
            uploadTable.uploadTableList = fileUploadModel.file_path;
        });
        return _objectSpreadProps(_objectSpread({
            tableListRef: tableListRef,
            uploadTips: uploadTips,
            uploadTable: uploadTable,
            uploadConfig: uploadConfig,
            realizeOptions: realizeOptions,
            applicableOptions: applicableOptions,
            tagConfig: tagConfig
        }, toRefs(fileUploadSchemaData), toRefs(fileUploadModelData), toRefs(uploadTable)), {
            validateName: validateName,
            uploadCover: uploadCover,
            uploadRemove: uploadRemove,
            handleDeleteFile: handleDeleteFile,
            tagChangeEvent: tagChangeEvent,
            handleChange: handleChange,
            applicableToolsChangeEvent: applicableToolsChangeEvent,
            realizeMethodChangeEvent: realizeMethodChangeEvent
        });
    }
});
